import classNames from 'classnames'
import { Calendar as CalendarIcon } from 'iconoir-react'
import moment from 'moment'
import { ReactElement } from 'react'
import { formatDate } from 'app/date.utils'

type Props = {
  date?: string | null
  time?: string | null
  type?: string | null
  className?: string
}

/**
 * Appointment `time` is stored 24-hour ("HH:mm"); render it 12-hour with a
 * meridiem ("10:00 AM") so the pill is unambiguous. Anything that isn't a valid
 * 24-hour time (e.g. already "10:00 AM") passes through unchanged.
 */
function formatTime(time?: string | null): string | undefined {
  if (!time) return undefined
  const parsed = moment(time, [`HH:mm`, `H:mm`], true)
  return parsed.isValid() ? parsed.format(`h:mm A`) : time
}

export function AppointmentBookedDivider({ date, time, type, className }: Props): ReactElement {
  const details = [date ? formatDate({ value: date, dateOnly: true }) : undefined, formatTime(time), type || undefined]
    .filter(Boolean)
    .join(` · `)

  return (
    <div data-testid="appointment-booked-divider" className={classNames(`flex items-center`, className)}>
      <div className="h-px w-full bg-ai-accent-light" />
      <div className="flex shrink-0 items-center gap-1 rounded border-[0.5px] border-ai-accent-light bg-surface-muted px-1.5 py-0.5">
        <CalendarIcon className="h-3.5 w-3.5 shrink-0 text-blue-700" />
        <span className="whitespace-nowrap text-center text-label-xs font-medium text-blue-700">
          Appointment booked{details ? `: ${details}` : ``}
        </span>
      </div>
      <div className="h-px w-full bg-ai-accent-light" />
    </div>
  )
}
